import React, { lazy } from 'react';
import { Gift } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    number: 'Bonus 1',
    title: 'The Practice Plan Generator',
    desc: 'Master the art of session timing. High-efficiency templates for 60, 90, and 120-minute sessions.',
    image: 'https://cdn.magicpatterns.com/uploads/bcJRorPt47CYLnz2rkBpPw/88a984cf-38c1-4fe0-b4cd-df54d6b9f99b-mockup.webp'
  }, {
    number: 'Bonus 2',
    title: '50 "Secret" Baseline Plays',
    desc: 'The ultimate tactical playbook to score easy points under the rim against any defense.',
    image: 'https://cdn.magicpatterns.com/uploads/3QvpfYWFK2Xh8aHMSYTGqe/bd0f838b-4f55-41bf-9c1c-f4111975f733-mockup.webp'
  }, {
    number: 'Bonus 3',
    title: 'The Parent Communication Toolkit',
    desc: 'Proven scripts to handle difficult conversations, set boundaries, and build a positive team culture.',
    image: 'https://cdn.magicpatterns.com/uploads/6iCbwNfsZhhdmLAmhBQ6Gx/247fc9e6-9265-40fa-a2e7-51066759b89d-mockup.webp'
  }, {
    number: 'Bonus 4',
    title: 'Strength & Agility for Youth',
    desc: 'The physical standards and routines that distinguish elite athletes. No specialized gym equipment required.',
    image: 'https://cdn.magicpatterns.com/uploads/7hzWqs1Dhmv4uyuhnMouak/69d8e799-ec75-4ad6-86af-ac6bbbeb7b9c-mockup.webp'
  }, {
    number: 'Bonus 5',
    title: 'The Scouting & Stats Toolkit',
    desc: 'Analyze opponents like a pro and track the high-impact metrics that actually drive wins.',
    image: 'https://cdn.magicpatterns.com/uploads/w87JUSu2s2gfUNgLLCBp7k/a5ffe5e0-b8b4-4577-9c9b-ecd2ff173e71-mockup.webp'
  }];
  return <section className="bg-bb-cream py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-26">
      <div className="absolute top-20 right-0 w-96 h-96 bg-bb-orange/15 rounded-full blur-3xl pointer-events-none" data-id="element-27"></div>
      <div className="absolute bottom-20 left-0 w-96 h-96 bg-bb-charcoal/10 rounded-full blur-3xl pointer-events-none" data-id="element-28"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-29">
        <div className="text-center mb-14" data-id="element-30">
          <div className="bg-bb-orange/15 text-bb-orange-dark font-bold text-xs px-4 py-1.5 rounded-full mb-6 inline-flex items-center gap-2 w-fit mx-auto uppercase tracking-[0.2em]" data-id="element-31">
            <Gift className="w-4 h-4" data-id="element-32" /> 5 Premium Bonuses Included
          </div>
          <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl md:text-5xl text-bb-charcoal leading-tight mb-4 tracking-tight" data-id="element-33">
            Plus, get <span className="text-bb-orange" data-id="element-34">5 elite bonuses</span>{' '}
            absolutely FREE
          </h2>
          <p className="text-bb-slate text-base sm:text-lg max-w-2xl mx-auto" data-id="element-35">
            Exclusive resources that transform your coaching efficiency and team
            results — included at no extra cost with your order today.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-36">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-md border border-bb-line hover:border-bb-orange/40 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col" data-id="element-37">
              <div className="relative mb-5 overflow-hidden rounded-xl bg-gradient-to-br from-bb-light to-bb-court aspect-square" data-id="element-38">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" width="400" height="400" data-id="element-39" />
                <div className="absolute top-3 left-3 bg-bb-orange text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide shadow-md" data-id="element-40">
                  {bonus.number}
                </div>
                <div className="absolute top-3 right-3 bg-bb-charcoal text-bb-cream text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider shadow-md" data-id="element-41">
                  🎁 Free
                </div>
              </div>
              <h3 className="font-display font-semibold uppercase text-lg text-bb-charcoal leading-tight mb-2 tracking-wide" data-id="element-42">
                {bonus.title}
              </h3>
              <p className="text-bb-slate text-sm leading-relaxed" data-id="element-43">
                {bonus.desc}
              </p>
            </div>)}

          {/* Decorative card showing total value */}
          <div className="bg-gradient-to-br from-bb-charcoal to-bb-dark rounded-2xl p-6 shadow-md flex flex-col items-center justify-center text-center text-white relative overflow-hidden" data-id="element-44">
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-bb-orange/30 rounded-full blur-2xl" data-id="element-45"></div>
            <Gift className="w-12 h-12 text-bb-orange mb-3 relative z-10" data-id="element-46" />
            <p className="text-white/80 text-xs uppercase tracking-[0.2em] mb-2 relative z-10" data-id="element-47">
              All included in
            </p>
            <p className="font-display font-bold uppercase text-3xl text-white mb-2 relative z-10" data-id="element-48">
              The 6-in-1 Bundle
            </p>
            <p className="text-white/75 text-sm leading-relaxed relative z-10" data-id="element-49">
              The 5 bonuses are yours for free with your order today.
            </p>
          </div>
        </div>
      </div>
    </section>;
}